import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

// Base URL
const API_BASE = `${API_ENDPOINTS.common}/comments`;

export interface CommentDTO {
  id?: string; // UUID
  entityType: string;
  entityId: string; // UUID
  tenantId?: string; // UUID
  tenantName?: string; // Name of the tenant
  parentCommentId?: string | null; // UUID or null for top-level comments
  userId?: string; // UUID
  username?: string;
  message?: string;
  messageType?: string; //'TEXT' | 'IMAGE' | 'VIDEO' | 'FILE';
  contentUrl?: string;
  thumbnailUrl?: string;
  fileName?: string;
  mimeType?: string;
  createdAt?: string; // ISO string format from server
  updatedAt?: string;
  isDeleted?: boolean;
  replies?: CommentDTO[]; // Nested replies
}

export interface CommentFilterDTO {
  entityType?: string;
  entityId?: string;
  userId?: string;
  messageType?: string;
  isDeleted?: boolean;
  createdAtFrom?: string;
  createdAtTo?: string;
}
/**
 * Create a new comment
 * @param data - CommentDTO object
 */
export const postComment = (commentDto: CommentDTO) => {
  return axios.post(`${API_BASE}`, commentDto);
};

/**
 * Update an existing comment
 * @param commentId - UUID of the comment
 * @param data - Updated CommentDTO object
 */
export const updateComment = (commentId: string, commentDto: CommentDTO) => {
  return axios.put(`${API_BASE}/${commentId}`, commentDto);
};

/**
 * Soft delete a comment
 * @param commentId - UUID of the comment
 */
export const deleteComment = (commentId: string) => {
  return axios.delete(`${API_BASE}/${commentId}`);
};

/**
 * Get a comment by ID
 * @param commentId - UUID of the comment
 */
export const fetchCommentById = (commentId: string) => {
  return axios.get(`${API_BASE}/${commentId}`);
};

/**
 * Search comments by entityType, entityId, messageType, userId, etc.
 * @param filter - Partial CommentDTO object used for searching
 * @param page - Page number (default 0)
 * @param size - Page size (default 10)
 * @param sort - Sorting string (e.g., 'createdAt,desc')
 */
export const searchComments = (
  filter: CommentFilterDTO,
  page: number = 0,
  size: number = 100,
  sort: string = 'createdAt,desc'
) => {
  return axios.post(`${API_BASE}/search?page=${page}&size=${size}&sort=${sort}`, filter);
};

 
export const createCommentWithUploads = async (
  comment: CommentDTO,
  files?: File[]
): Promise<CommentDTO[]> => {
  try {
    const formData = new FormData();

    // Append the comment as JSON
    formData.append('comment', JSON.stringify(comment));

    // Append each file
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('files', file);
      });
    }

    // Perform the POST request
    const response = await axios.post<CommentDTO[]>(
      `${API_BASE}/uploads`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    // Return the list of comments
    return response.data;
  } catch (error: any) {
    console.error('Failed to create comment:', error);
    throw error?.response?.data || new Error('Unknown error occurred while creating comment');
  }
};